import {
  reactive,
  readonly as defineReadonly,
  type InjectionKey,
  provide,
  inject,
  UnwrapRef,
} from 'vue';

export interface CreateContextOptions {
  readonly?: boolean;
  createProvider?: boolean;
  native?: boolean;
}

type ShallowUnwrap<T> = {
  [P in keyof T]: UnwrapRef<T[P]>;
};

export function createContext<T>(
  context: any,
  key: InjectionKey<T> = Symbol(undefined),
  options: CreateContextOptions = {}
) {
  const { readonly = true, createProvider = false, native = false } = options;
  const state = reactive(context);
  const provideData = readonly ? defineReadonly(context) : state;
  if (!createProvider) {
    provide(key, native ? context : provideData);
  }
  return {
    state,
  };
}
export function useContext<T>(key: InjectionKey<T>, native?: boolean): T;
export function useContext<T>(
  key: InjectionKey<T>,
  defaultValue?: any,
  native?: boolean
): T;
export function useContext<T>(
  // eslint-disable-next-line default-param-last
  key: InjectionKey<T> = Symbol(undefined),
  defaultValue?: any
): UnwrapRef<T> {
  return inject(key, defaultValue || {});
}
